import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight, Zap } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 600px (past hero on mobile)
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const element = document.querySelector('#comprar');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-321">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-brand-200 shadow-[0_-10px_30px_rgba(0,0,0,0.1)] px-3 py-2.5 safe-bottom" data-id="element-322">
          <button onClick={scrollToPricing} className="w-full bg-accent-600 hover:bg-accent-700 text-white font-bold py-3 px-4 rounded-xl flex items-center justify-between shadow-lg active:scale-95 transition-transform" data-id="element-323">
            <div className="flex items-center gap-2" data-id="element-324">
              <Zap className="w-4 h-4" data-id="element-325" />
              <span className="text-sm" data-id="element-326">
                <span className="line-through text-white/60 mr-1.5 text-xs" data-id="element-327">
                  $49.990
                </span>
                <span className="font-extrabold" data-id="element-328">$19.990</span>
              </span>
            </div>
            <div className="flex items-center gap-1 text-sm" data-id="element-329">
              <span data-id="element-330">Quiero el Plan PRO</span>
              <ChevronRight className="w-4 h-4" data-id="element-331" />
            </div>
          </button>
        </motion.div>}
    </AnimatePresence>;
}